export {
  Card as ResourceCard,
  type CardProps as ResourceCardProps,
} from "./ui";
